export default class Component {

    constructor(eObj) {
        this.component = eObj;

        if(this.constructor == Component){
            throw new Error("Object of Abstract Class 'Component' cannot be created");
        }

        document.addEventListener("DOMContentLoaded", () => {
            this.ready();
        });
    }

    ready(){
        throw new Error("Abstract Method 'ready' has no implementation");
    }
}